import React from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from '../Icons/CheckIcon';

interface Props {
  milesRange?: any;
}

const InstructionsModalBatch: React.FC<Props> = ({ milesRange }) => {
  const { t } = useTranslation(['includeTeam']);

  return (
    <>
      <span className="instruction-title">{t('instructions_to_send')}</span>
      <div className="instructions-wrapper">
        <div className="instruction-box">
          <CheckIcon />
          <p>{t('verify')}</p>
        </div>
        <div className="instruction-box">
          <CheckIcon />
          <p>
            {t('fill')}
            <strong>{t('cant_cancel')}</strong>
          </p>
        </div>
        <div className="instruction-box">
          <CheckIcon />
          <p>
            {t('case_cpf1')} {milesRange?.minMiles} {t('case_cpf2')} {milesRange?.maxMiles} {t('case_cpf3')}
            {/* {t('case_cpf')} <strong>{t('replaced')}</strong> */}
          </p>
        </div>
        <div className="instruction-box">
          <CheckIcon />
          <p>{t('include_up_to')}</p>
        </div>
        <div className="instruction-box">
          <CheckIcon />
          <p>{t('inform_team')}</p>
        </div>
        <div className="instruction-box">
          <CheckIcon />
          <p>
            {t('save_in_format')} <strong>.txt</strong>
          </p>
        </div>
      </div>
    </>
  );
};

export default InstructionsModalBatch;
